import { render, staticRenderFns } from "./DetailLedger.vue?vue&type=template&id=9228c15c"
import script from "./DetailLedger.vue?vue&type=script&lang=js"
export * from "./DetailLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports